import { SymbolTileData } from 'widgets/symbolTile/components/symbolTileData';
import Tooltip from 'utils/components/Tooltip/Tooltip';
import * as tooltips from 'widgets/symbolTile/components/chart/help/symbolTileChartTooltips';
import React from 'react';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import { useWidgetContext } from 'widgets/WidgetContext';
import classNames from 'classnames';
import { getItemTimeOrLastItem } from 'utils/timeseries/timeSeriesUtils';

interface SymbolTileChartHeaderValuesProps {
    data: SymbolTileData;
}

export function SymbolTileChartHeaderValues(
    props: SymbolTileChartHeaderValuesProps
) {
    const { data } = props;

    const { widgetKey } = useWidgetContext();

    let { price, absChange, percChange, className } = data.formattedValues;

    const time = usePointedTime('SymbolTileChartHeaderValues' + widgetKey);
    if (time !== undefined) {
        const item = getItemTimeOrLastItem(data.timeSeries, time);
        if (item) {
            price = item?.formattedValues.price;
            absChange = item?.formattedValues.absChange;
            percChange = item?.formattedValues.percChange;
            className = item?.formattedValues.className;
        }
    }

    const cssClasses = classNames('SymbolTileChartHeaderValues', className);

    return (
        <div className={cssClasses}>
            <div className="price">{price}</div>
            <div className="price-change">
                <div className="abs-change">
                    <Tooltip text={tooltips.absChange}>{absChange}</Tooltip>
                </div>
                <div className="perc-change">
                    <Tooltip text={tooltips.percChange}>{percChange}</Tooltip>{' '}
                </div>
            </div>
        </div>
    );
}
